import { createAction } from '@reduxjs/toolkit';
import { GenericActionPayload } from 'types/redux-types';

const generateIssue = createAction<GenericActionPayload>('techSupport/generateIssue');

export {
  generateIssue,
};
